import React from 'react'
import { Input } from 'antd'
import { Box, IconButton, Paper } from '@mui/material'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import CloseIcon from '@mui/icons-material/Close'

import type { BlockPayload } from '../../../types'
import { UploadZone } from '../UploadZone'
import { IMAGE_MAX_SIZE } from '../utils'

interface Props {
  payload: { images?: Array<{ url: string; alt?: string }> }
  onChange: (payload: BlockPayload) => void
}

export const SliderBlock: React.FC<Props> = ({ payload: p, onChange }) => {
  const images = p?.images ?? []

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {images.length > 0 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {images.map((img, idx) => (
            <Paper
              key={idx}
              variant="outlined"
              sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <span style={{ width: 24, textAlign: 'center', fontSize: 12, color: '#8b949e' }}>
                {idx + 1}
              </span>
              <Box
                component="img"
                src={img.url}
                alt=""
                sx={{ width: 40, height: 40, borderRadius: 1, objectFit: 'cover', bgcolor: 'action.hover' }}
              />
              <Input
                placeholder="Alt text..."
                value={img.alt ?? ''}
                onChange={(e) => {
                  const next = [...images]
                  next[idx] = { ...next[idx], alt: e.target.value }
                  onChange({ images: next })
                }}
                bordered={false}
                style={{ flex: 1 }}
              />
              <IconButton
                size="small"
                color="error"
                onClick={() => {
                  const next = images.filter((_, i) => i !== idx)
                  onChange({ images: next })
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Paper>
          ))}
        </Box>
      )}
      <UploadZone
        accept="image/*"
        multiple
        color="#FBBF24"
        icon={<AddPhotoAlternateIcon />}
        title={images.length ? 'เพิ่มรูปอีก' : 'เพิ่มรูปภาพ'}
        hint="(เลือกได้หลายรูปพร้อมกัน) PNG, JPG, WEBP"
        maxSize={IMAGE_MAX_SIZE}
        onUploadMultiple={(items) => {
          onChange({ images: [...images, ...items] })
        }}
      />
    </Box>
  )
}
